export default __webpack_public_path__ + "static/media/icon-linkedin.f0f0966b.svg";